module.exports = __webpack_public_path__ + "img/white-top-center.99a9b3fd.png";